import React, { useState } from "react";
import Page from "../../Components/Page";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import FetchHook from "../../Api/FetchHooks";

const PettyCash = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [loading, response, request] = FetchHook();

  const [user, setUser] = useState(location?.state?.user || loggedInUser);
  const [data, setData] = useState([]);

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  return (
    <Page
      title={"Petty Cash Records"}
      actions={
        <Box display={"flex"}>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() =>
              openDialog("nominate_guarantor", "Nominate Guarantor Form")
            }
          >
            Petty Cash
          </Button>
        </Box>
      }
    >
      <Card>
        <CardContent>Petty Cash Records </CardContent>
      </Card>
    </Page>
  );
};

export default PettyCash;
